import React from 'react';

import { MDText } from 'i18n-react';

import VrmCheckerWrapper from '../../../wordpress/VrmCheckerWrapper/VrmCheckerWrapper';
import LocalTexts from '../../utilities/WordpressText.json';

import styles from '../../WordpressPages.scss';

const LocalT = new MDText(LocalTexts);

export const VRMSection: React.FC = () => (
  <div className={styles.sideBarSection}>
    <h3>{LocalT.translate('vehicleLookup.title')}</h3>
    <p>{LocalT.translate('vehicleLookup.strap')}</p>
    <VrmCheckerWrapper />
  </div>
);
